import createSvgIcon from "./utils/create_icon"

const Undo = createSvgIcon(<path d="M7.707 5.293a1 1 0 0 1 0 1.414L5.414 9H17a5 5 0 0 1 0 10h-3a1 1 0 1 1 0-2h3a3 3 0 1 0 0-6H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z" fill="currentColor" />, "Undo")
export default Undo
